import { MessageCircle } from "lucide-react";

export default function AssistantFloatingTrigger({ onClick }) {
  return <button className="assistant-floating-trigger" type="button" onClick={() => onClick("")} aria-label="Abrir Guia do Leitor" data-testid="assistant-floating-trigger"><MessageCircle size={18} /><span>pergunte ao guia</span></button>;
}
